export default {
  en: {
    title: "{orgName}'s Security Profile",
    overview: {
      lastAssessment: 'Last assessment:',
      nextReassessment: 'Reassessment:',
      orgDetails: 'Organisation details',
      assessment: 'Security assessment',
      notRequired: 'Not required domains',
      notRequired2:
        'You can still choose to fill these out if you would like to share the answers with other clients',
      added: '{n} added',
      banners: {
        submitAssessmentTitle: 'Submit your assessment',
        submitAssessmentText:
          "You're almost there - submit your details and let your clients see your answers",
        requiresAttentionTitle: 'New questions require your attention',
        requiresAttentionText:
          'You have 1 new question to answer since your last assessment | You have {n} new questions to answer since your last assessment',
        moreInfoTitle: "You've been asked to fill out more information",
        moreInfoText:
          "We've highlighted the additional controls & domains below you need to fill out",
        reassessmentDueTitle: 'Your reassessment is due {dueDate}',
        reassessmentOverdueTitle: 'Your reassessment is overdue',
        reassessmentDueText:
          "We'll ask you to confirm the answers you’ve previously provided and answer any new questions.",
        getStarted: 'Get started',
      },
    },
    domainCard: {
      outOfScope: 'Out of scope',
      notStarted: 'Not started',
      numAnswered: '{x} of {y} answered',
      numConfirmed: '{x} of {y} confirmed',
    },
  },
};
